import { render, staticRenderFns } from "./DeliveryType.vue?vue&type=template&id=169f8f00"
import script from "./DeliveryType.vue?vue&type=script&lang=js"
export * from "./DeliveryType.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports